<div class="ul-shell">

  <!-- ── empty state ── -->
  <div *ngIf="!items.length" class="ul-empty">
    <div class="ul-empty__icon-wrap">
      <mat-icon>person_off</mat-icon>
    </div>
    <span class="ul-empty__label">{{ 'GENERAL.NO_RESULTS_FOUND' | translate }}</span>
    <span class="ul-empty__sub">NO AGENTS MATCH YOUR QUERY</span>
  </div>

  <!-- ── grid ── -->
  <div
    *ngIf="items.length"
    class="ul-grid"
    infinite-scroll
    [scrollWindow]="false"
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="150"
    (scrolled)="onScrollDown()"
  >

    <div class="row g-3 px-1">
      <div class="col-12 col-sm-6 col-md-4 col-xl-3" *ngFor="let item of items">
        <app-user-list-item
          [userData]="item"
          (onUserClick)="onItemEvent($event)"
          (onDelete)="onDeleteEvent($event)"
        ></app-user-list-item>
      </div>
    </div>
  </div>

</div>
